"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSelectField = void 0;
const react_1 = __importStar(require("react"));
const Tooltip_1 = require("../../modals/popovers/Tooltip");
const ClosableHeader_styles_1 = require("../ClosableHeader/ClosableHeader.styles");
const EditableTitle_1 = require("../EditableTitle");
const SelectInputField_styles_1 = require("../SelectInputField/SelectInputField.styles");
const ProductSelectField_styles_1 = require("./ProductSelectField.styles");
const ProductSelectField = ({ value, disabled, label, options, inlineTranslation, translationEditHandler, infoText, onChange, }) => {
    const [opened, setOpened] = (0, react_1.useState)(false);
    const onChangeFn = (0, react_1.useMemo)(() => (e) => {
        onChange(e.target.value);
    }, [onChange]);
    const onClickFn = (0, react_1.useMemo)(() => () => {
        setOpened(!opened);
    }, [opened]);
    return (react_1.default.createElement(ProductSelectField_styles_1.Wrapper, null,
        label && inlineTranslation && translationEditHandler && (react_1.default.createElement(ClosableHeader_styles_1.LabelWrapper, null,
            react_1.default.createElement("span", null,
                react_1.default.createElement(EditableTitle_1.EditableTitle, { name: label, editHandler: (isCancelled, value) => translationEditHandler ? translationEditHandler(isCancelled, value !== null && value !== void 0 ? value : "") : {}, isEditable: inlineTranslation })),
            infoText && react_1.default.createElement(Tooltip_1.Tooltip, { message: infoText, type: "info" }))),
        react_1.default.createElement(SelectInputField_styles_1.Select, { onChange: (e) => onChangeFn(e), onClick: onClickFn, value: value, disabled: disabled }, options.map((option, index) => (react_1.default.createElement(ProductSelectField_styles_1.Option, { key: index, value: option.value, disabled: option.disabled }, option.disabled ? `${option.name} ${option.disabledText}` : option.name))))));
};
exports.ProductSelectField = ProductSelectField;
exports.default = exports.ProductSelectField;
//# sourceMappingURL=ProductSelectField.js.map